'use strict';

const PLATFORM_URLS = Object.freeze({
  website: 'https://w3booster.com',
  client: 'https://client.w3booster.com',
  api: 'https://api.w3booster.com',
  realtime: 'wss://api.w3booster.com/realtime/',
  overlayCompositor: 'https://overlay.w3booster.com',
  static: 'https://static.w3booster.com',
  matchVision: 'https://match-vision.apps.w3booster.com'
});

const LOCAL_PLATFORM_URLS = Object.freeze({
  website: 'http://localhost:8084',
  client: 'https://localhost:4200',
  api: 'https://localhost:25080',
  realtime: 'wss://localhost:25081/'
});

function platformUrl(origin, pathname = '/') {
  return new URL(pathname, `${origin.replace(/\/+$/, '')}/`).toString();
}

module.exports = { PLATFORM_URLS, LOCAL_PLATFORM_URLS, platformUrl };
